import { Action } from "redux";
import {IMainMenu, INavigation} from "@montana/models/generated/cms.interface";

export enum SiteStructureActionTypes {
    SITE_STRUCTURE_FETCH_SUCCESS = "@@site-structure/SITE_STRUCTURE_FETCH_SUCCESS",
    SITE_STRUCTURE_FETCH = "@@site-structure/SITE_STRUCTURE_FETCH",
}

export type IStructureActions = IFetchSiteStructureSuccessAction | IFetchSiteStructureAction;

export interface IFetchSiteStructureSuccessAction extends Action<SiteStructureActionTypes.SITE_STRUCTURE_FETCH_SUCCESS> {
    siteStructure: INavigation;
}

export type IFetchSiteStructureAction = Action<SiteStructureActionTypes.SITE_STRUCTURE_FETCH>;

export const fetchSiteStructureSuccess = (siteStructure: IMainMenu): IFetchSiteStructureSuccessAction => ({
    type: SiteStructureActionTypes.SITE_STRUCTURE_FETCH_SUCCESS,
    siteStructure,
});

export const fetchSiteStructure = (): IFetchSiteStructureAction => ({
    type: SiteStructureActionTypes.SITE_STRUCTURE_FETCH,
});

